const UTM_KEY = 'utm_params';

export function getUTMParams() {
  return JSON.parse(localStorage.getItem(UTM_KEY) || '{}');
}

export function clearUTMParams() {
  localStorage.removeItem(UTM_KEY);
}

export function getUTMParamsAsHeaders() {
  const utmParams = getUTMParams();

  const headers: Record<string, string> = {};
  for (const key in utmParams) {
    const headerName = `x-${key.replace('_', '-')}`;
    headers[ headerName ] = utmParams[ key ];
  }
  return headers;
}

export function captureUTMParams() {
  const params = new URLSearchParams(window.location.search);
  const utmParams = {
    utm_source: params.get('utm_source'),
    utm_medium: params.get('utm_medium'),
    utm_campaign: params.get('utm_campaign'),
    utm_term: params.get('utm_term'),
    utm_content: params.get('utm_content'),
  };

  if (Object.values(utmParams).some(value => value)) {
    localStorage.setItem(UTM_KEY, JSON.stringify(utmParams));
  }
}